export const getOrigin = () => {
	return window.location.origin;
};
